import { create } from 'zustand';
import type { Room } from '@shared/types/room.types';
import type { Player } from '@shared/types/player.types';
import type { Color } from '@shared/types/chess.types';

interface RoomStore {
  room: Room | null;
  roomCode: string | null;
  playerColor: Color | null;
  isHost: boolean;
  opponent: Player | null;
  
  // Actions
  setRoom: (room: Room) => void;
  setRoomCode: (code: string) => void;
  setPlayerColor: (color: Color) => void;
  setOpponent: (player: Player | null) => void;
  leaveRoom: () => void;
}

export const useRoomStore = create<RoomStore>((set) => ({
  room: null,
  roomCode: null,
  playerColor: null,
  isHost: false,
  opponent: null,
  
  setRoom: (room) => set({ 
    room, 
    roomCode: room.code,
    isHost: false // This will be set separately when we know the player identity 
  }),
  
  setRoomCode: (code) => set({ roomCode: code }),
  
  setPlayerColor: (color) => set({ playerColor: color }),
  
  setOpponent: (player) => set({ opponent: player }),
  
  leaveRoom: () => set({
    room: null,
    roomCode: null,
    playerColor: null,
    isHost: false,
    opponent: null,
  }),
}));